import { Box, Card, CardContent, IconButton, Tooltip, Typography } from "@mui/material"
import OrderInfoSection from "./orderInfoSection"
import VisibilityIcon from '@mui/icons-material/Visibility';
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

const OrderCard = ({ order , onClick = () => {}}) => {
    return (
      <Box sx={{ position : "relative" , width: { xs: "90%" } , boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)" , bgcolor : "#f9fafb", borderRadius : "10px"}}>
      <CardContent sx={{pr : 0.1 ,display : "flex" , alignItems:"center" , justifyContent : "space-between"}} onClick={onClick} >
          <Box>
          <OrderInfoSection title={"Ordre nr"} trucateVal={true} value={order.order_serial} />
          <OrderInfoSection title={"Rekv. nr"} value={order.order_ref} />
          <OrderInfoSection title={"Ordre kommentar"} trucateVal={true} value={order.order_comment} />
          <OrderInfoSection title={"Ordre dato"} value={order.purchase_date} />
          <OrderInfoSection title={"Bruger"} value={order.billing_to_name} />
          <OrderInfoSection title={"Leverings adresse"} trucateVal={true} value={order.billing_to_address} />
          <OrderInfoSection title={"Ordre sum"} value={`${order.subtotal} dkk`} />
          </Box>
          <Tooltip title="vise mer" placement="top">
          <IconButton
            sx={{cursor : 'pointer' , ":hover" : {color : "#8b816b"} , transform : "rotate(-90deg)"}}
          >
            <ExpandCircleDownOutlinedIcon sx={{fontSize : '28px'}}  />
          </IconButton>
          </Tooltip>
      </CardContent>
  </Box>
    )
}

export default OrderCard